import { BodyCaption, BodyTiny, COLORS } from "@bikdotai/bik-component-library";
import { ManifestGlass } from "@bikdotai/bik-component-library/icons";
import { PRE_SALES_AGENT_NAME } from "./constants";
import { AttachedAgentChipStyled } from "./style";

// Shown on a template node on the canvas when an agent is attached to it.
const AttachedAgentChip = () => {
  return (
    <AttachedAgentChipStyled>
      <ManifestGlass size={28} />
      <div className="attached-agent-chip__text">
        <BodyCaption numberOfLines={1} color={COLORS.background.inverseLight}>
          {PRE_SALES_AGENT_NAME}
        </BodyCaption>
        <BodyTiny numberOfLines={1} color={COLORS.content.placeholder}>
          Run on replies
        </BodyTiny>
      </div>
    </AttachedAgentChipStyled>
  );
};

export default AttachedAgentChip;
